import {Container} from 'pixi.js';

export interface IReactView {
    container: Container;
    state: any;
    componentDidUpdate?: (prevState: Readonly<any>, snapshot?: any) => void;
    componentWillUnmount?: () => void;
    componentDidMount?: () => void;
    render: () => JSX.Element;
}
